export const creditPeriodDefault = 30;
export const creditPeriodDefault = 30;
